// extracted by mini-css-extract-plugin
module.exports = {"card":"ldFd0","card-shadow":"_2Lixp","card-title":"Sln-5","card-body":"_7uYcp","bordered":"CoETs","clickable":"e9e3B"};